var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import EPopper from '@common/ui/EPopper/EPopper.vue';
import { computed, provide, readonly, watch } from 'vue';
import { provideDropdownKey } from '@common/ui/EDropdown/provideKey';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EDropdown',
    props: /*#__PURE__*/ _mergeModels({
        allowedPlacements: { default: function () { return ['top', 'bottom']; } },
        offsetAmount: { default: 10 },
        appendToBody: { type: Boolean, default: true },
        trigger: { default: 'manual' },
        disabled: { type: Boolean, default: false },
        hideArrow: { type: Boolean, default: false },
        theme: { default: 'light' },
        followReferenceWidth: { type: Boolean },
        fullwidth: { type: Boolean },
        closeOnClickReference: { type: Boolean },
        renderType: {}
    }, {
        "visible": __assign({ type: Boolean }, { default: false }),
        "visibleModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["outsideClick", "close"], ["update:visible"]),
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var emit = __emit;
        var props = __props;
        var visibleModel = _useModel(__props, 'visible');
        var dropdownTheme = computed(function () {
            return {
                dark: 'e-tooltip__arrow--dark',
                light: 'e-e-tooltip__arrow--light'
            }[props.theme];
        });
        var updateVisible = function (v) {
            visibleModel.value = v;
        };
        watch(visibleModel, function (v) {
            if (!v) {
                emit('close');
            }
        });
        provide(provideDropdownKey, {
            visible: readonly(visibleModel),
            updateVisible: updateVisible
        });
        __expose({
            updateVisible: updateVisible,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(EPopper, {
                visible: visibleModel.value,
                "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) { return ((visibleModel).value = $event); }),
                "allowed-placements": _ctx.allowedPlacements,
                "append-to-body": _ctx.appendToBody,
                "close-on-click-reference": _ctx.closeOnClickReference,
                disabled: _ctx.disabled,
                "follow-reference-width": _ctx.followReferenceWidth,
                fullwidth: _ctx.fullwidth,
                "hide-arrow": _ctx.hideArrow,
                "offset-amount": _ctx.offsetAmount,
                "render-type": _ctx.renderType,
                trigger: _ctx.trigger,
                class: "e-dropdown",
                onOutsideClick: _cache[1] || (_cache[1] = function ($event) { return (emit('outsideClick')); })
            }, {
                reference: _withCtx(function (_a) {
                    var maxHeight = _a.maxHeight;
                    return [
                        _renderSlot(_ctx.$slots, "overlay", {
                            maxHeight: maxHeight,
                            theme: _ctx.theme
                        })
                    ];
                }),
                default: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "default")
                ]; }),
                _: 3
            }, 8, ["visible", "allowed-placements", "append-to-body", "close-on-click-reference", "disabled", "follow-reference-width", "fullwidth", "hide-arrow", "offset-amount", "render-type", "trigger"]));
        };
    }
});
